import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import anim_line from "../../img/winter.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";
import {Activity, Plus } from 'lucide-react';
import Snackbar from "../../../Snackbar";
import { createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin";
import AppMenuCardBlue from "../AppCards/AppMenuCardBlue";
import { getProductByProductId } from "../../../api";
import AreYouSurePopUp from "../../Create/CreateContent/ContentPopUp/AreYouSurePopUp";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
import SkillsProductAddMore from "./SkillsProductAddMore";
import SEOKeyWordsProductAddMore from "./SEOKeyWordsProductAddMore";
const SEOProduct = ({setActiveCardOverview,baseUrl})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

 const [loader , setLoader] =useState({status:false});
 const [seofriendlyURL, setSeofriendlyURL] = useState(courseData?.seofriendlyURL?courseData?.seofriendlyURL:"");
 const [seoPageTitle, setSeoPageTitle] = useState(courseData?.seoPageTitle?courseData?.seoPageTitle:"");
 
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"seo":"");

 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"Home Tutor Offering":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"Course":"Course";
 const [animate, setAnimate] = useState(false);

 useEffect(() => {
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])

    let seoKeywords= courseData?.seoKeywords?JSON.parse(courseData?.seoKeywords):[]
 const [itemArr, setItemArr] = useState(seoKeywords);
 
     useEffect(() => {
        seoKeywords?.length !== 0?setItemArr(seoKeywords):
        setItemArr([{ no:1, id: generateTimestamp()+1
            ,paragraph:"" },{ no:2, id: generateTimestamp()+2
                ,paragraph:"" }]);
          
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
   

  const handleCreateProduct=()=>{
  
  
  
  setLoader({status:true});
  
    const apiData = dispatch(createCourseByAdminV2({seofriendlyURL:seofriendlyURL,seoPageTitle:seoPageTitle,
        seoKeywords:JSON.stringify(itemArr),type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editType,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        if(response?.course){
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
    setSeofriendlyURL(response?.course?.seofriendlyURL);
    setProductID(response?.course?.postId);
  
   setGoNextPopUp(true);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    
    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.id !== id);
        setItemArr(filteredItems);
      };
      const updateItemParagraph = (id, Paragraph) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, paragraph :Paragraph } : item
        
        ); 
        
        setItemArr(updatedItems);
      };
     
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"><div  className=" contentPageScroller " style={{background:"#fff",borderRadius:"25px"}}>
      <div  className="CreateCourseStepsOuterRight ">
   
      <h1 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-50px)',marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>   Set Up  <span className="coloredTextV1" >SEO For Your {TypeTitle}?</span> </h1>
     <h2 style={{"textAlign":"center",
        transform: animate ? 'scale(1)' : 'scale(.9)',marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>   <span className="coloredTextV1" >SEO Friendly URL</span> </h2>
       
 <div  className="  SEOURlInput"style={{
        transform: animate ? 'translateY(0)' : 'translateY(50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
        transform: animate ? 'scale(1)' : 'scale(.2)',marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
      fontSize:"25px",width:"220px"}} placeholder={`Add Seo Friendly Name `} type="text"
   name="courseTitle" value={"www.yourwebsite.com"} disabled /><div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.2)',marginBottom:"0px",
    opacity: animate ? 1 : 0,
    transition: 'transform 1.5s ease, opacity 1.5s ease',
  fontSize:"25px",width:"10px"}}>/</div><input onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.2)',marginBottom:"0px",
    opacity: animate ? 1 : 0,
    transition: 'transform 2s ease, opacity 2s ease',
  fontSize:"25px",width:"50px"}} placeholder={` `} type="text"
 name="courseTitle" value={"store"} disabled /><div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
    transform: animate ? 'scale(1)' : 'scale(.2)',marginBottom:"0px",
    opacity: animate ? 1 : 0,
    transition: 'transform 2.5s ease, opacity 2.5s ease',
fontSize:"25px",width:"10px"}}>/</div>
<input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
        transform: animate ? 'scale(1)' : 'scale(.2)',marginBottom:"0px",textAlign:"left",
        opacity: animate ? 1 : 0,
        transition: 'transform 3s ease, opacity 3s ease',
      fontSize:"25px"}} placeholder={`eg., my-title `} type="text"
   name="courseTitle" value={seofriendlyURL} onChange={(e)=>setSeofriendlyURL(e.target.value.replace(/[^a-zA-Z0-9-]/g, ''))} />
  </div><div className="CreateCourseStepsOuterTwo" style={{
        transform: animate ? 'translateY(0)' : 'translateY(50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 3s ease, opacity 3s ease',
      background:"#f9f9f9",borderRadius:"25px"}} ><div>
  <h2 style={{"textAlign":"center",
        transform: animate ? 'scale(1)' : 'scale(.1)',marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 4s ease, opacity 4s ease',
      }}>   <span className="coloredTextV1" >SEO Friendly {TypeTitle} Page Title</span> </h2>
       
 <div  className="  ikcraft_login-input-card"style={{
        transform: animate ? 'translateY(0)' : 'translateY(50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 3s ease, opacity 3s ease',
      }}>
        <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(50px)',marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 3.5s ease, opacity 3.5s ease',textAlign:"left",
      fontSize:"25px"}} placeholder={`eg., My New ${TypeTitle} Title`} type="text"
   name="courseTitle" rows="4" value={seoPageTitle} onChange={(e)=>setSeoPageTitle(e.target.value)} />

        </div></div><div> 
        <h2 style={{"textAlign":"center",
        transform: animate ? 'scale(1)' : 'scale(.2)',marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 5s ease, opacity 5s ease',
      }}>   <span className="coloredTextV1" >SEO Friendly Keywords</span> </h2>
 
        <div  className="ikcraft_login-input-card"style={{
     transform: animate ? 'translateY(0)' : 'translateY(50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 2s ease, opacity 1s ease',
   }}> <div className="" >
{flattenedData?flattenedData.map((item, index) => 
        (<div  style={{"textAlign":"center",
            transform: animate ? 'translateY(0)' : 'translateY(50px)',marginBottom:"0px",
            opacity: animate ? 1 : 0,
            transition: `transform ${5+index}s ease, opacity ${5+index}s ease`,
          }} index={index} key={item.id} 
          >
            <div
            
             
            ><SEOKeyWordsProductAddMore index={index} key={item.id} 
        
         paragraph={item.paragraph}  id={item.id} 
           changeItemParagraph={updateItemParagraph } onRemove={removeItem} />
          </div>
          
          </div>)):'' }
          <div align="center" > 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="coloredTextV1" style={{marginTop:"15px",padding:"10px",}}>Add New SEO Keyword</div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>setItemArr([...itemArr, {no: itemArr.length, id: generateTimestamp()+2
      ,  paragraph:"" }])}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
          </div>
   
    </div> </div></div>
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/trial`)}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateProduct()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Update":"Save"} </button>
     
  </div>
  
    <div  className="ikcraft_login-input-card">
   
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
 <div></div>
 {goNextPopUp?<NextStepCardPopUp loadingText="Going Next..."  title="Next Step> Set Appearance.   Let's Go Next" type="addAproxContent"
 closePopUp={()=>{setGoNextPopUp(false)}}
 onClickPopup={(type)=>{setTimeout(()=>{
  history.push(`${baseUrl}/appearance`)
 },1000)
  }}/>:""}

  </div></div>
</>}
    </>

}

export default SEOProduct;

